export default "__VITE_ASSET__DEyRDBQc__"